export var Type;
(function (Type) {
    Type[Type["AABB"] = 1] = "AABB";
    Type[Type["ARC"] = 2] = "ARC";
    Type[Type["CIRCLE"] = 3] = "CIRCLE";
    Type[Type["CONE"] = 4] = "CONE";
    Type[Type["CUBIC"] = 5] = "CUBIC";
    Type[Type["CUBIC3"] = 6] = "CUBIC3";
    Type[Type["CYLINDER"] = 7] = "CYLINDER";
    Type[Type["ELLIPSE"] = 8] = "ELLIPSE";
    Type[Type["GROUP"] = 9] = "GROUP";
    Type[Type["LINE"] = 10] = "LINE";
    Type[Type["LINE3"] = 11] = "LINE3";
    Type[Type["PATH"] = 12] = "PATH";
    Type[Type["PLANE"] = 13] = "PLANE";
    Type[Type["POINTS"] = 14] = "POINTS";
    Type[Type["POINTS3"] = 15] = "POINTS3";
    Type[Type["POLYGON"] = 16] = "POLYGON";
    Type[Type["POLYGON3"] = 17] = "POLYGON3";
    Type[Type["POLYLINE"] = 18] = "POLYLINE";
    Type[Type["POLYLINE3"] = 19] = "POLYLINE3";
    Type[Type["QUAD"] = 20] = "QUAD";
    Type[Type["QUAD3"] = 21] = "QUAD3";
    Type[Type["QUADRATIC"] = 22] = "QUADRATIC";
    Type[Type["QUADRATIC3"] = 23] = "QUADRATIC3";
    Type[Type["RECT"] = 24] = "RECT";
    Type[Type["SPHERE"] = 25] = "SPHERE";
    Type[Type["TRIANGLE"] = 26] = "TRIANGLE";
    Type[Type["TRIANGLE3"] = 27] = "TRIANGLE3";
    Type[Type["RAY"] = 28] = "RAY";
    Type[Type["RAY3"] = 29] = "RAY3";
    Type[Type["TEXT"] = 30] = "TEXT";
    Type[Type["TEXT3"] = 31] = "TEXT3";
})(Type || (Type = {}));
